<template>
    <div class="photo-and-text" :class="{'text-wrap': content.image.attributes.wrap}">

        <template v-if="content.image.attributes.position === 'below' || (content.image.attributes.position === 'right' && !content.image.attributes.wrap) ">
            <render-editor-js :content="content.text.content" :component="{}"/>
            <div>
                <div class="photo-frame" :class="['position-' + content.image.attributes.position, 'width-' + content.image.attributes.width]">
                    <img :src="content.image.content" />
                </div>
            </div>
        </template>
        <template v-else>
            <div>
                <div class="photo-frame" :class="['position-' + content.image.attributes.position, 'width-' + content.image.attributes.width]">
                    <img :src="content.image.content" />
                </div>
            </div>
            <render-editor-js :content="content.text.content" :component="{}"/>
        </template>
<!--        <template v-else>-->
<!--            <div class="photo-frame" :class="['position-' + content.image.attributes.position, {'wrapped': content.image.attributes.wrap}]">-->
<!--                <img :src="content.image.content"  />-->
<!--            </div>-->
<!--            <render-editor-js :content="content.text.content" :component="{}" class="photo-text"/>-->
<!--        </template>-->
        <div class="is-clearfix"></div>
    </div>
</template>

<script>
    import RenderEditorJs from "./RenderEditorJs";

    export default {
        components: {RenderEditorJs},
        props: ['content'],
        data: function() {
            return {

            }
        }
    };
</script>

<style scoped lang="scss">
    .photo-and-text {
        display: flex;

        // Phones: no room to sit beside text — stack the photo above it
        @media (max-width: 768px) {
            display: block;

            // !important: the position-/width- rules below are more specific
            .photo-frame,
            &.text-wrap .photo-frame {
                float: none !important;
                width: 100% !important;
                max-width: 100% !important;
                margin: 0 0 1rem !important;
            }
        }

        &.text-wrap {
            display: block;

            .photo-frame {

                &.position-left {
                    float: left;
                }

                &.position-right {
                    float: right;
                }

                &.width-25 {
                    width: 25%;
                }
                &.width-35 {
                    width: 35%;
                }
                &.width-50 {
                    width: 50%;
                }
                &.width-100 {
                    max-width: 100%;
                }

            }

            .photo-text {
                flex-grow: 1;
            }
        }

        .photo-frame {

            border-radius: 5px;
            margin: 0 2rem 2rem;
            border: 1px solid #e7e7e7;
            padding: 10px;
            line-height: 0;

            img {
                border-radius: 3px;
            }
        }

    }
</style>
